
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, ref, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";
import moment from "moment";
import TableTab from "@/components/kt-datatable/TableTab.vue";
import PaginationUtill from "../util/PaginationUtill";

export default defineComponent({
  name: "DataTable",

  components: {
    TableTab,
  },
  setup() {
    interface Tableheader {
      name: string;
      key: string;
      sortable: boolean;
    }
    let accountId = computed(()=> store.getters.AccountId);

    const tableValues = ref([]);
    const tableValuesR = ref([]);
    const TableHeaders = ref<Array<Tableheader>>();
    const OriginalTableHeaders = ref<Array<Tableheader>>();
    const colnames = ref();
    const downloadurl = "api/siteaddittionremoval/downloadGasFile";
    const downloadprops = ref();
    //   const initHistoricConsumption = ref([]);
    const fromDate = ref(new Date());
    const toDate = ref(new Date());
    const addition = ref(false);
    const removal = ref(false);

    const loading = ref<boolean>(false);

    TableHeaders.value = PaginationUtill.assetAdditionGas;
    OriginalTableHeaders.value = PaginationUtill.assetAdditionGas;
    colnames.value = PaginationUtill.assetAdditionGas.map((a) => a.key);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Site Additions & Removals Gas", ["NA"]);
      addition.value = false;
      removal.value = false;
    });

    async function getContent() {
      loading.value = true;
      const fromdateval: any = fromDate.value;
      const toDateval: any = toDate.value;
      let domainName = store.getters.DomainName;
      const accountInfo: any = {
        accountid: accountId.value,
        fromdate: moment(fromdateval).format("YYYY-MM-DD 00:00:00"),
        todate: moment(toDateval).format("YYYY-MM-DD 00:00:00"),
        DomainName: domainName,
      };
      downloadprops.value = accountInfo;

      ApiService.post("api/siteaddittionremoval/siteaddremgas", accountInfo)
        .then((resp) => {
          tableValues.value = resp.data.gasdetails.map((a) => a);
          tableValuesR.value = resp.data.gasdetailsRemove.map((a) => a);         
          addition.value = true;
          loading.value = false;
          if(removal.value){
            openAssetRemoval();
          }
        })
        .catch((a) => {
          loading.value = false;
          console.log("Api Log Error", a);
        });
    }

    function openAssetAddition() {
      addition.value = true;
      removal.value = false;
       TableHeaders.value = PaginationUtill.assetAdditionGas;
      OriginalTableHeaders.value = PaginationUtill.assetAdditionGas;
      colnames.value = PaginationUtill.assetAdditionGas.map((a) => a.key);
    }
    function openAssetRemoval() {
      addition.value = false;
      removal.value = true;
       TableHeaders.value = PaginationUtill.assetRemovalGas;
      OriginalTableHeaders.value = PaginationUtill.assetRemovalGas;
      colnames.value = PaginationUtill.assetRemovalGas.map((a) => a.key);
    }
    const pageheaderRemovals = "Site Removals";
    const pageheaderAddition = "Site Additions";
    return {
      pageheaderRemovals,
      pageheaderAddition,
      OriginalTableHeaders,
      getContent,
      TableHeaders,
      colnames,
      fromDate,
      toDate,
      openAssetAddition,
      openAssetRemoval,
      addition,
      removal,
      tableValues,
      tableValuesR,
      loading,
      downloadurl,
      downloadprops,
    };
  },
});
